import {
  enableProdMode,
  provideAppInitializer,
  inject,
  LOCALE_ID,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import {
  provideRouter,
  withPreloading,
  PreloadAllModules,
  withDebugTracing,
} from '@angular/router';
import { environment } from './environments/environment';
import { AppConfigService } from 'app/services/app-config.service';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ReqInterceptorPageUpdateService } from 'app/services/req-interceptor-page-update.service';
import { initializeApp } from 'app/services/init-app.service';
import { ErrorInterceptorService } from './app/services/error-interceptor.service';
import { CommonModule } from '@angular/common';
import { routes } from './app/app-routing.module';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { BsCommon, LocaleDateTimeAdapter } from '@bsquare/angular-common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ReactiveFormsModule } from '@angular/forms';
import { OAuthModule } from 'angular-oauth2-oidc';
import { AppComponent } from './app/components/app/app.component';
import { DateTimeAdapter, OWL_DATE_TIME_FORMATS } from '@danielmoncada/angular-datetime-picker';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(routes, withPreloading(PreloadAllModules), withDebugTracing()),
    importProvidersFrom(
      CommonModule,
      BrowserModule,
      BsCommon,
      FontAwesomeModule,
      ReactiveFormsModule,
      OAuthModule.forRoot({
        resourceServer: {
          sendAccessToken: true,
        },
      }),
    ),
    AppConfigService,
    { provide: HTTP_INTERCEPTORS, useClass: ReqInterceptorPageUpdateService, multi: true },
    provideAppInitializer(() => {
      const initializerFn = initializeApp(inject(AppConfigService));
      return initializerFn();
    }),
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptorService, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
    { provide: LOCALE_ID, useValue: 'en-US' },
    // Tell date-fns date parser to use locale for input
    {
      provide: OWL_DATE_TIME_FORMATS,
      useValue: {
        parseInput: 'L, LTS',
        fullPickerInput: 'L, LTS',
        datePickerInput: 'L',
        timePickerInput: 'LTS',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
      },
    },
    {
      provide: DateTimeAdapter,
      useClass: LocaleDateTimeAdapter,
    },
  ],
}).catch((err: unknown) => console.error(err));
